//

import { normalize } from 'normalizr';
import { browserHistory } from 'react-router';

import { simplApi } from '../../api/simplApi';
import { activity } from './schemas';

import { receiveProject } from './project';
import { receiveFile } from './file';
import { receivePerson } from './person';
import { receiveStaff } from './staff';
import { getLocalizedActivityStrings } from '../../models/Activity';
import { fetchTotalData } from './totaldata';
import handleApiError from '../../helpers/handleApiError';
import { addFeedback } from './feedback';

const _ = require('lodash');

// ------------------------------------
// Constants
// ------------------------------------
export const REQUEST_ACTIVITY = 'REQUEST_ACTIVITY';
export const RECEIVE_ACTIVITY = 'RECEIVE_ACTIVITY';
export const SET_ACTIVITY = 'SET_ACTIVITY';
export const SET_ACTIVITY_FORM = 'SET_ACTIVITY_FORM';
export const CLOSE_ACTIVITY_FORM = 'CLOSE_ACTIVITY_FORM';
export const REMOVE_ACTIVITY = 'REMOVE_ACTIVITY';

// ------------------------------------
// Actions
// ------------------------------------

export function requestActivity() {
  return {
    type: REQUEST_ACTIVITY,
  };
}

export function receiveActivity(activities) {
  return {
    type: RECEIVE_ACTIVITY,
    payload: {
      activities,
    },
  };
}

export function setActivity(activityId) {
  return {
    type: SET_ACTIVITY,
    payload: activityId,
  };
}

export function setActivityForm(activityId = 0, draft) {
  return {
    type: SET_ACTIVITY_FORM,
    payload: activityId,
    draft,
  };
}

export function closeActivityForm() {
  return {
    type: CLOSE_ACTIVITY_FORM,
  };
}

export const fetchActivity = activityId => dispatch => {
  dispatch(requestActivity());

  const url =
    typeof activityId !== 'undefined' && activityId !== null
      ? `activity/${activityId}`
      : 'activity';

  return simplApi(url)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        dispatch(handleApiError(json));
      } else {
        let preparedActivities;

        if (typeof json.id === 'undefined') {
          preparedActivities = normalize(json, [activity]);
        } else {
          preparedActivities = normalize(json, activity);
        }

        // console.log('activities', preparedActivities);

        dispatch(receiveActivity(preparedActivities.entities.activities));
        // dispatch(receiveCompany(preparedActivities.entities.companies))
        dispatch(receiveProject(preparedActivities.entities.projects));
        dispatch(receiveFile(preparedActivities.entities.files));

        // they should get fetched via totalData, no real need to fetch them again.
        if (typeof activityId !== 'undefined' && activityId !== null) {
          dispatch(receiveStaff(preparedActivities.entities.staffs));
          dispatch(receivePerson(preparedActivities.entities.persons));
        }
      }
    });
};

export function removeActivity(activityId) {
  return {
    type: REMOVE_ACTIVITY,
    payload: activityId,
  };
}

export const deleteActivity = activityId => dispatch => {
  const url = `activity/${activityId}`;
  const options = { method: 'delete' };

  return simplApi(url, options)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        dispatch(handleApiError(json));
      } else {
        dispatch(removeActivity(activityId));
        dispatch(addFeedback('warning', 'Aktivität gelöscht'));
      }
    });
};

export const saveActivity = (newActivity, redirect = true) => dispatch => {
  dispatch(requestActivity());

  let url = 'activity/';
  const options = { method: 'post', body: newActivity };
  if (typeof newActivity.id !== 'undefined' && newActivity.id !== null) {
    // // console.log('updating')
    url = `${url}${newActivity.id}`;
    options.method = 'put';
  }

  return simplApi(url, options)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        dispatch(handleApiError(json));
      } else {
        const preparedActivities = normalize(json, activity);

        dispatch(receiveActivity(preparedActivities.entities.activities));
        dispatch(receiveProject(preparedActivities.entities.projects));
        dispatch(receiveFile(preparedActivities.entities.files));

        dispatch(addFeedback('success', 'Aktivität gespeichert'));
        dispatch(fetchTotalData());

        if (redirect) {
          browserHistory.push(`/activity/${json.id}`);
        } else {
          return json;
        }
      }
    });
};
export const actions = {
  requestActivity,
  receiveActivity,
  setActivity,
  setActivityForm,
  closeActivityForm,
  fetchActivity,
  saveActivity,
  deleteActivity,
  removeActivity,
};
const ACTIVITY_ACTION_HANDLERS = {
  [REQUEST_ACTIVITY]: state => ({
    ...state,
    fetching: true,
  }),
  [SET_ACTIVITY]: (state, action) => ({ ...state, current: action.payload }),
  [SET_ACTIVITY_FORM]: (state, action) => ({
    ...state,
    formOpen: true,
    formTarget: action.payload,
    draft: action.draft,
  }),
  [REMOVE_ACTIVITY]: (state, action) => ({
    ...state,
    activities: _.omit(state.activities, action.payload),
  }),
  [CLOSE_ACTIVITY_FORM]: state => ({
    ...state,
    formOpen: false,
    formTarget: null,
  }),
  [RECEIVE_ACTIVITY]: (state, action) => {
    const stateActivities = state.activities;
    _.forOwn(action.payload.activities, (_activity, id) => {
      const newActivity = _activity;
      newActivity.extraInfo = getLocalizedActivityStrings(newActivity);
      if (
        typeof newActivity.linkedWith !== 'undefined' &&
        newActivity.linkedWith !== null
      ) {
        newActivity.associated = newActivity.linkedWith.name;
      }
      if (typeof stateActivities[id] === 'object') {
        Object.assign(stateActivities[id], stateActivities[id], newActivity);
      } else {
        stateActivities[id] = newActivity;
      }
    });
    return {
      ...state,
      activities: stateActivities,
      fetching: false,
    };
  },
}; // ------------------------------------ // ------------------------------------ // Reducer

export const initialState = {
  fetching: false,
  current: null,
  formOpen: false,
  formTarget: null,
  draft: {},
  activities: {},
};
export default function activityReducer(state = initialState, action) {
  const handler = ACTIVITY_ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/modules/activity.js